module.exports = __webpack_public_path__ + "images/icons/flags/CO-123e6a0b.svg";